import { ParseError } from "@/repositories/shared/errors/parseError";
import { HttpFindId, IFindIdParser } from "../userRepository.types";
import { ok, err, Result } from "neverthrow";
import dayjs from "dayjs";
import { FindId } from "@/domain/entities/user/findId";
import { IFindIdData } from "@/domain/entities/user/user.types";
import { injectable } from "inversify";

@injectable()
export class FindIdParser implements IFindIdParser {
  constructor() {}

  toDomain(data: HttpFindId): Result<IFindIdData, ParseError> {
    try {
      const findIdData: IFindIdData = {
        id: data.authKey,
        joinDate: data.joinTs ? dayjs(data.joinTs).format("YYYY.M.D") : "",
        isSuccess: false,
      };
      const findId = new FindId(findIdData);
      return ok(findId);
    } catch (error: any) {
      return err(new ParseError(error.message));
    }
  }
}
